import { RouteConfig } from 'vue-router'

const AdMobile = () => import('../activity/ad/Index.vue')
const AdPC = () => import('../activity/ad/IndexPc.vue')

export const adRoute: RouteConfig = {
  path: '/ad-mobile-activity',
  name: 'ad-mobile-activity',
  component: AdMobile,
  meta: {
    title: '体智云',
  },
  props: (route) => ({ ...route.query, ...route.params }),
  beforeEnter: (to, from, next) => {
    let channel = to.query.channel
    channel = channel ? channel.toString() : ''
    // 投放渠道 jycpa 需要使用之前旧的PC页面
    if (channel.startsWith('jycpa')) {
      const oldMobileHomePage = `${location.protocol}//${location.host}/about/campus/mobile?channel=${channel}`
      location.href = oldMobileHomePage
    } else {
      next()
    }
  },
}

export const adPCRoute: RouteConfig = {
  path: '/ad-pc-activity',
  name: 'ad-pc-activity',
  component: AdPC,
  meta: {
    title: '天天跳绳',
  },
  props: (route) => ({ ...route.query, ...route.params }),
  beforeEnter: (to, from, next) => {
    let channel = to.query.channel
    channel = channel ? channel.toString() : ''
    // 投放渠道 jycpa 需要使用之前旧的PC页面
    if (channel.startsWith('jycpa')) {
      const oldPcHomePage = `${location.protocol}//${location.host}/about/campus/pc?channel=${channel}`
      location.href = oldPcHomePage
    } else {
      next()
    }
  },
}

export default [adRoute, adPCRoute]
